import { createIdSlice, idSliceSymbol } from '../utils/action/createElementSlice';
import { action } from '@sas/nova-commons/action';
const SliceState = createIdSlice({
    elementName: 'birdLayout',
    initialState: {},
    reducers: {
        update: function (state, action) {
            return Object.assign(Object.assign({}, state), action.payload.data);
        },
        set: function (_state, action) {
            return action.payload.data;
        },
        setPosition: function (state, action) {
            return Object.assign(Object.assign({}, state), { position: action.payload.data });
        },
        setConstraints: function (state, action) {
            return Object.assign(Object.assign({}, state), { constraints: action.payload.data });
        },
        setPromptConstraints: function (state, action) {
            return Object.assign(Object.assign({}, state), { promptConstraints: action.payload.data });
        },
        setAboutInfoLayout: function (state, action) {
            return Object.assign(Object.assign({}, state), { aboutInfoLayout: action.payload.data });
        },
        setBreadcumbLayout: function (state, action) {
            return Object.assign(Object.assign({}, state), { breadcrumbLayout: action.payload.data });
        },
        setScrollbars: function (state, action) {
            return Object.assign(Object.assign({}, state), { scrollbars: action.payload.data });
        },
        setStyle: function (state, action) {
            return Object.assign(Object.assign({}, state), { style: action.payload.data });
        },
        setChildKeys: function (state, action) {
            return Object.assign(Object.assign({}, state), { childKeys: action.payload.data });
        },
        setIsSingleObject: function (state, action) {
            return Object.assign(Object.assign({}, state), { isSingleObject: action.payload.data });
        },
        setTitlePadding: function (state, action) {
            return Object.assign(Object.assign({}, state), { titlePadding: action.payload.data });
        },
    },
});
const UpdateState = 'birdLayout/layout/update';
const NotifyInvalidateLayout = 'birdLayout/layout/notifyInvalidateLayout';
export const BirdLayoutState = {
    actions: Object.assign(Object.assign({}, SliceState.actions), { updateState: (layout) => action(UpdateState, layout), notifyInvalidateLayout: () => action(NotifyInvalidateLayout) }),
    actionTypes: Object.assign(Object.assign({}, SliceState.actionTypes), { updateState: UpdateState, notifyInvalidateLayout: NotifyInvalidateLayout }),
    // `idSliceSymbol` needed for RootState deletes
    reducer: (state = { [idSliceSymbol]: true }, anyAction) => {
        const action = anyAction;
        if (action.type === NotifyInvalidateLayout) {
            return state;
        }
        if (action.type === UpdateState) {
            const layout = action.payload;
            const nextState = Object.assign({}, state);
            for (const id of Object.keys(layout)) {
                nextState[id] = Object.assign(Object.assign({}, state[id]), layout[id]);
            }
            return nextState;
        }
        return SliceState.reducer(state, anyAction);
    },
};
export const setConstraints = BirdLayoutState.actions.setConstraints;
